import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { UtilityService } from "../shared/services/Utility.service";
import * as $ from 'jquery';
import { HttpClient } from '@angular/common/http';
import { UserSettings } from './usersettings';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { GridApi, ColumnApi } from 'ag-grid-community';
import Swal from 'sweetalert2';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
import bb from "billboard.js";
var moment = require('moment');
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { Subscription } from 'rxjs';
import { AppServiceService } from './services/product.service';
import { MainMenuService } from './services/menuservice.service';
import { AuthService } from '../../components/auth/auth.service';

@Component({
    selector: 'unit-template',
    template: require('./UnitTemplate.html'),
    styles: [``],
})

export class UnitTemplateComponent implements OnInit {
    @Output() SelectedUnit = new EventEmitter();
    @Input("dValue") dvalue: any;
    @Input("FYearList") FYearList: any;
    @Input("UnitList") UnitList: any;

    static parameters = [UtilityService, HttpClient, NgbModal, AppServiceService, MainMenuService, AuthService];
    unitList: any;
    FyearList: any;
    currentUnit: any;
    selectedFYear: any;
    d: any;
    UnitInfo: any;
    selectedUnit: any;
    CurrUnitID: any;
    CurrFYear: any;
    busy: Subscription;
    DailyOutstandingInvoicesReference: NgbModalRef;
    highlightIndex: number = 0;
    unitSearchText: string = "";
    filteredUnitList: any[] = [];

    f_ChkNum(p_value) {
        var Num = Number(p_value);
        if (Num) {
            return Num;
        }
        return 0;
    }
    AuthService: any;
    constructor(public utilityService: UtilityService, public http: HttpClient, private modalService: NgbModal, private service: AppServiceService, private menuService: MainMenuService, private _AuthService = AuthService) {
        this.http = http;
        this.modalService = modalService;
        this.AuthService = _AuthService;
        this.menuService.UserPermissionmyMethodSubject.subscribe(Permission => {
            if (Permission.length == 0) {
                return false;
            }
            this.currentUnit = Permission[0];
        })
    }

    toast = Swal.mixin({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 3000,
        backdrop: `rgba(30, 30, 37, 0.4)`
    });

    f_chkString(p_value) {
        var Val = (p_value ? p_value.toString() : "").trim();
        return Val;
    }

    f_chknum(p_value) {
        var Val = Number(p_value);
        if (Val) {
            return Val;
        }
        return 0;
    }

    ngOnInit(): void {
        this.d = this.dvalue;
        this.unitList = this.UnitList;
        this.FyearList = this.FYearList;
        this.selectedFYear = this.currentUnit.Fyear;
        this.selectedUnit = this.currentUnit.Unit_ID;
        this.CurrUnitID = this.currentUnit.Unit_ID;
        this.CurrFYear = this.selectedFYear;
        this.filteredUnitList = this.unitList;
        
        this.setHighlightIndexFromSelectedUnit();
        this.focusAndScrollCurrentItem();
        setTimeout(() => {
            $('#SearchUnitFromList').focus().select();
        }, 300);
    }

   /*  onItemChange(item) {
        this.currentUnit = item;
    } */

    updateUnit() {
        if (this.CurrUnitID == this.currentUnit.Unit_ID && this.CurrFYear == this.selectedFYear) {
            $('#unit-popup-close').click();
            return false;
        }
        Swal({
            html: "your changes will be lost" + "<br>Are you sure you want to Continue.",
            type: 'warning',
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Continue',
            customClass: 'swal-warning-custom',
            focusConfirm: true,
        }).then(choice => {
            if (choice.value) {
                let permission = JSON.parse(localStorage.getItem('permission'));
                permission[0].Fyear = this.selectedFYear;//this.currentInfo.selectedFYear;
                permission[0].State_ID = this.currentUnit.State_ID;
                permission[0].Unit_GST_No = this.currentUnit.Unit_GST_No;
                permission[0].Unit_ID = this.currentUnit.Unit_ID;
                permission[0].Unit_Name = this.currentUnit.Unit_Name;
                permission[0].Shelf_Life = this.currentUnit.Shelf_Life;
                permission[0].Sales_ShelfLife = this.currentUnit.Sales_ShelfLife;
                permission[0].Return_ShelfLife = this.currentUnit.Return_ShelfLife;
                permission[0].DefaultSalesMarginPercent = this.currentUnit.DefaultSalesMarginPercent;
                permission[0].DefaultPurchaseMarginPercent = this.currentUnit.DefaultPurchaseMarginPercent;
                permission[0].IsUnitChange = 1;
                permission[0].Unit_State_Code = this.currentUnit.State_Code;
                permission[0].Unit_City_Desc = this.currentUnit.City_Desc;
                permission[0].Unit_Address_1 = this.currentUnit.Unit_Address1;
                permission[0].Unit_Address_2 = this.currentUnit.Unit_Address2;
                permission[0].Unit_Address_2 = this.currentUnit.Unit_Address2;
                permission[0].Pincode_ID = this.currentUnit.Pincode_ID;
                permission[0].Is_Picking_Allow = this.currentUnit.Is_Picking_Allow;
                permission[0].Is_POImport_Allow = this.currentUnit.Is_POImport_Allow;
                permission[0].Company_Full_Address = this.currentUnit.Company_Full_Address;
                permission[0].TCS_Applicable = this.currentUnit.TCS_Applicable;
                permission[0].TCS_WithPan_Percentage = this.currentUnit.TCS_WithPan_Percentage;
                permission[0].TCS_WithoutPan_Percentage = this.currentUnit.TCS_WithoutPan_Percentage;
                permission[0].TCS_Invoice_Amount = this.currentUnit.TCS_Invoice_Amount;
                permission[0].Is_Sales_Return_Loose_Qty_Allow = this.currentUnit.Is_Sales_Return_Loose_Qty_Allow;
                permission[0].Is_Sales_Breakage_Loose_Qty_Allow = this.currentUnit.Is_Sales_Breakage_Loose_Qty_Allow;
                permission[0].Is_Flood_Cess_Allow = this.currentUnit.Is_Flood_Cess_Allow;
                permission[0].Flood_Cess_Percentage = this.currentUnit.Flood_Cess_Percentage;
                permission[0].Flood_Cess_Applied_On = this.currentUnit.Flood_Cess_Applied_On;
                permission[0].Max_Disc_Per = this.currentUnit.Max_Disc_Per;
                permission[0].Manufacturer_Warehouse_Flag = this.currentUnit.Manufacturer_Warehouse_Flag;
                permission[0].Warehouse_IDs = this.currentUnit.Warehouse_IDs;
                permission[0].Is_Sales_Scheme_Allow = this.currentUnit.Is_Sales_Scheme_Allow;
                permission[0].IS_HO = this.currentUnit.IS_HO;
                permission[0].TDS_WithPan_Percentage = this.currentUnit.TDS_WithPan_Percentage;
                permission[0].TDS_WithoutPan_Percentage = this.currentUnit.TDS_WithoutPan_Percentage;
                permission[0].Expiry_Deduction = this.currentUnit.Expiry_Deduction;
                permission[0].Is_GRN_Hold = this.currentUnit.Is_GRN_Hold;
                permission[0].Is_WST_Hold = this.currentUnit.Is_WST_Hold;
                permission[0].Is_SR_Hold = this.currentUnit.Is_SR_Hold;
                permission[0].Is_SBAE_Hold = this.currentUnit.Is_SBAE_Hold;
                permission[0].MDM_Domain_Name = this.currentUnit.MDM_Domain_Name;
                permission[0].MDM_Login_Name = this.currentUnit.MDM_Login_Name;
                permission[0].MDM_Password = this.currentUnit.MDM_Password;
                permission[0].MDM_Distributor_Code = this.currentUnit.MDM_Distributor_Code;
                permission[0].uvalue = this.currentUnit.uvalue;
				permission[0].AES_DEC = this.currentUnit.AES_DEC;
				permission[0].CDN_Enabled = this.currentUnit.CDN_Enabled;
				permission[0].CDN_Domain = this.currentUnit.CDN_Domain;
				permission[0].Bank_Charges = this.currentUnit.Bank_Charges;
				permission[0].BrkExpAutoPostDays = this.currentUnit.BrkExpAutoPostDays;
                permission[0].GRN_Margin_Check = this.currentUnit.GRN_Margin_Check;
                permission[0].Is_CNDN_CUS_ROUNDOFF = this.currentUnit.Is_CNDN_CUS_ROUNDOFF;
                permission[0].ERP_Version = this.currentUnit.ERP_Version;
                permission[0].Unit_EmailID = this.currentUnit.Unit_EmailID;
                permission[0].EnableWhatsApp = this.currentUnit.EnableWhatsApp;
                //CurrentFYear
                var selectedFYear = this.selectedFYear;
                var SelectYearList = [];
                SelectYearList = this.FyearList.filter(xxx => { return xxx.FYear == selectedFYear });
                if (SelectYearList.length > 0) {
                    permission[0].CurrentFYear = SelectYearList[0].CurrentFYear;
                    permission[0].Current_Fyear_FromDate = SelectYearList[0].Fyear_FromDate;
					permission[0].Current_Fyear_ToDate = SelectYearList[0].To_Date;
                    permission[0].Fyear_FromDate = SelectYearList[0].Fyear_FromDate;
                    permission[0].Fyear_ToDate = SelectYearList[0].Fyear_ToDate;
                    permission[0].Fyear_Is_Current = SelectYearList[0].Is_Current;
                    permission[0].Fyear_Locked = SelectYearList[0].Locked;
                    permission[0].FYear1 = SelectYearList[0].FYear1;
                }
                permission[0].warehousedetails = this.currentUnit.warehousedetails;
                permission[0].UnitCount = this.currentUnit.UnitCount;
                permission[0].DGS_Vendor_ID = this.currentUnit.DGS_Vendor_ID;
                permission[0].ShelfExpDay = this.currentUnit.ShelfExpDay;
                permission[0].USER_PICK_WAREHOUSE = permission[0].USER_PICK_WAREHOUSE;
                permission[0].EInvoice_Comp_Code = this.currentUnit.EInvoice_Comp_Code;
                permission[0].STATUS_URL = this.currentUnit.STATUS_URL;
                permission[0].VPA = this.currentUnit.VPA;
                permission[0].MC = this.currentUnit.MC;
                permission[0].Mode = this.currentUnit.Mode;
                permission[0].pgMerchantId = this.currentUnit.pgMerchantId;
                permission[0].secretKey = this.currentUnit.secretKey;
                permission[0].Stockist_ID = this.currentUnit.Stockist_ID;
                //permission[0].Invoice_Tracking_Picklistwise_flag = this.currentUnit.Invoice_Tracking_Picklistwise_flag;
                permission[0].ALLOW_DMY_PRODUCT_EXPIRY_FORMAT = this.currentUnit.ALLOW_DMY_PRODUCT_EXPIRY_FORMAT;
                permission[0].BUCKET_NAME = this.currentUnit.BUCKET_NAME;
                permission[0].Discount_Reversal = this.currentUnit.Discount_Reversal;
                // permission[0].DB_Name = this.currentUnit.DB_Name;
                
                localStorage.setItem('permission', JSON.stringify(permission));
                this.menuService.UserPermissionSetter();
                let xx = JSON.parse(localStorage.getItem('permission'))[0];
                // this.AuthService.GetSystemConfigDetails({ "Unit_ID": this.currentUnit.Unit_ID });
                this.utilityService.setPermission();
                this.SelectedUnit.emit(xx);
            } else {
                $('#unit-popup-close').click();
            }
        });
    }

    // highlightIndex: number = 0;

    setHighlightIndexFromSelectedUnit() {
    if (!this.unitList || !this.unitList.length) {
        this.highlightIndex = 0;
        return;
    }
    const idx = this.unitList.findIndex(u => u.Unit_ID === this.selectedUnit);
        this.highlightIndex = idx >= 0 ? idx : 0;
    }

    // Ensure index is inside bounds
    clampIndex(idx: number) {
        const total = this.unitList ? this.unitList.length : 0;
        if (total === 0) return 0;
        if (idx < 0) return 0;
        if (idx > total - 1) return total - 1;
        return idx;
    }

    onUnitKeydown(event: KeyboardEvent) {
    if (!this.unitList || !this.unitList.length) return;
        const total = this.filteredUnitList.length;

        // const total = this.unitList.length;
        const itemsPerRow = 3;
        let next = this.highlightIndex;

        switch (event.key) {
            case 'ArrowRight':
                next = this.highlightIndex + 1;
                if (next > total - 1) next = total - 1; // clamp to last
            break;
            case 'ArrowLeft':
                next = this.highlightIndex - 1;
                if (next < 0) next = 0;
            break;
            case 'ArrowDown':
                next = this.highlightIndex + itemsPerRow;
                if (next > total - 1) next = total - 1; // jump to last if beyond
            break;
            case 'ArrowUp':
                next = this.highlightIndex - itemsPerRow;
                if (next < 0) next = 0;
            break;
            case 'Enter':
                // ensure current index reflects selectedUnit before firing
                // this.selectedUnit = this.unitList[this.highlightIndex].Unit_ID;
                this.selectedUnit = this.filteredUnitList[this.highlightIndex].Unit_ID;
                // this.CurrUnitID = this.unitList[this.highlightIndex].Unit_ID;
                this.onItemChange(this.filteredUnitList[this.highlightIndex]);
                setTimeout(() => {
                    this.updateUnit();
                }, 200);
                
                event.preventDefault();
            
            return;
            default:
            return; // ignore other keys
        }

        // apply new index
        this.highlightIndex = this.clampIndex(next);

        // update selectedUnit for UI binding
        // this.selectedUnit = this.unitList[this.highlightIndex].Unit_ID;
        this.selectedUnit = this.filteredUnitList[this.highlightIndex].Unit_ID;
        // this.CurrUnitID = this.unitList[this.highlightIndex].Unit_ID;

        // reflect to DOM: focus + scroll
        this.focusAndScrollCurrentItem();

        event.preventDefault();
    }

    // Call this when user clicks/selects an item by mouse (ensure highlight matches click)
    onItemChange(item: any) {
        // your existing logic should remain — we only add highlight sync + focus
        this.selectedUnit = item.Unit_ID;
        // this.CurrUnitID = item.Unit_ID;
        this.currentUnit = item;
        // find index
        // this.highlightIndex = this.unitList.findIndex(u => u.Unit_ID === item.Unit_ID);
        // if (this.highlightIndex < 0) this.highlightIndex = 0;
        this.highlightIndex = this.filteredUnitList.findIndex(
            u => u.Unit_ID === item.Unit_ID
        );
        // ensure visible & focused
        this.focusAndScrollCurrentItem();
        // (don't remove or alter your existing onItemChange logic)
    }

    // Programmatically focus + scroll the highlighted element into view
    focusAndScrollCurrentItem() {
        setTimeout(() => {
            const items = document.querySelectorAll('.unit-item');
            const el = items[this.highlightIndex] as HTMLElement | undefined;
            if (!el) return;

            // Programmatically focus (tabindex="-1" required on each .unit-item)
            try { el.focus(); } catch (e) { /* ignore */ }

            // Scroll into view, center it for better visibility
            el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        }, 10);
    }

/* scrollUnitIntoView() {
    setTimeout(() => {
        const items = document.querySelectorAll('.unit-item');
        const target = items[this.highlightIndex] as HTMLElement;

        if (target) {
            target.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "nearest"
            });
        }
    }, 30);
} */

    filterUnitList() {
        const keyword = this.unitSearchText.toLowerCase().trim();

        if (keyword === "") {
            this.filteredUnitList = this.unitList;
        } else {
            this.filteredUnitList = this.unitList.filter(item =>
                item.Unit_Name.toLowerCase().includes(keyword) ||
                (item.Unit_Address1 || '').toLowerCase().includes(keyword) ||
                (item.Unit_EmailID || '').toLowerCase().includes(keyword) ||
                (item.Unit_GST_No || '').toLowerCase().includes(keyword)
            );
        }

        // reset highlightIndex to first item of filtered result
        // this.highlightIndex = 0;   ////////////////

        // if results exist, select first
        if (this.filteredUnitList.length > 0) {
            // this.selectedUnit = this.filteredUnitList[0].Unit_ID; ////////////////
            // this.focusAndScrollCurrentItem(); ////////////////
        }
    }

}

